export default "__VITE_ASSET__wGIewUrC__"